<template>
  <a-layout class="layout">
    <a-form-model ref="loginForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol"
      class="loginformClass">
      <div class="ant-form-item-control">
        <img style="width: 60%; margin-left: 10%;" src="../assets/gif/logogif3.gif" />
        <h1 class="login-h1">
          <a-icon type="user" />
          登录 | Login
        </h1>
      </div>
      <div class="ant-form-item-control">
        <a-form-model-item ref="safecode" label="安全码" prop="safecode">
          <a-input placeholder="输入安全码" v-model="form.safecode" type="text" autocomplete="off" @keyup.enter="login" />
        </a-form-model-item>
      </div>
      <div class="ant-form-item-control">
        <a-form-model-item ref="username" label="帐号" prop="username">
          <a-input placeholder="输入账号" v-model="form.username" type="text" autocomplete="off" @keyup.enter="login" />
        </a-form-model-item>
      </div>
      <div class="ant-form-item-control">
        <a-form-model-item ref="password" label="密码" prop="password">
          <a-input-password placeholder="输入密码" v-model="form.password" type="password" autocomplete="off"
            @keyup.enter="login" />
        </a-form-model-item>
      </div>

      <div class="ant-form-item-control">
        <a-form-model-item ref="validcode" label="验证码" prop="validcode">
          <a-input placeholder="验证码" v-model="form.validcode" type="text" autocomplete="off" class="vlidinput"
            @keyup.enter="login" />
          <img class="validcode" :src="vcodeUrl" alt="验证码" title="点击刷新" @click="RefreshVcode()" />
        </a-form-model-item>
      </div>


      <div class="ant-form-item-control">
        <a-form-model-item :wrapper-col="{ span: 14, offset: 8 }">
          <a-button type="primary" style="width: 30%" @click="login">
            登入
          </a-button>
        </a-form-model-item>
      </div>
    </a-form-model>

    <!-- 对话框 ------------------------------------->

    <a-modal v-model="visible" title="Google二次验证" @ok="modalOk">
      <a-form-model :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="验证码">
          <a-input v-model="formModel.TFACode" placeholder="输入Google二次验证码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout>



</template>

<script>
  export default {
    name: "Login",
    data() {
      return {
        vcodeUrl: this.axios.defaults.baseURL + "home/getvalidatecode?T=",
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        visible: false, //弹框状态
        form: {
          username: "",
          password: "",
          validcode: "",
        },
        formModel: {
          TFACode: ""
        },
        rules: {
          safecode: [
            {
              required: true,
              message: "请输入安全码",
              trigger: "blur",
            },
          ],
          username: [
            {
              trigger: "blur",
              validator: this.validateUid,
            },
          ],
          password: [
            {
              required: true,
              message: "请输入密码",
              trigger: "blur",
            },
          ],
          validcode: [
            {
              required: true,
              message: "请输入验证码",
              trigger: "blur",
            },
          ],
        },
      };
    },
    methods: {
      login() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            let params = {
              UserID: this.form.username,
              PassWord: this.form.password,
              Vcode: this.form.validcode,
              SafeCode: this.form.safecode
            };
            //sessionStorage.setItem("UserID", this.form.password);

            this.axios.post("/home/login", params).then((res) => {
              if (res.data) {
                if (res.code == 302) {
                  this.visible = true;
                }
                else {
                  this.visible = false;
                  sessionStorage.setItem("UserID", this.form.username);
                  sessionStorage.setItem("RoleType", res.data.RoleType);
                  sessionStorage.setItem("Code", res.data.Code);
                  this.$router.push("index");
                }

              } else {
                this.$message.error(res.error);
                this.RefreshVcode();
              }
            });
          } else {
            // 表单校验失败
            return false;
          }
        });
      },
      modalOk() {
        let params = {
          UserID: this.form.username,
          SafeCode: this.form.safecode,
          TFACode: this.formModel.TFACode
        };
        // 弹框确认动作
        this.axios.post("/home/validtfacode", params).then((res) => {
          if (res.data) {
            sessionStorage.setItem("UserID", this.form.username);
            sessionStorage.setItem("RoleType", res.data.RoleType);
            sessionStorage.setItem("Code", res.data.Code);

            this.$router.push("index");
          } else {
            this.$message.error(res.error);
            this.RefreshVcode();
          }
        });
      },
      UserRoute(obj) {
        this.$router.push({
          name: 'user',
          params: {
            name: 'user',
            userid: obj,
          }
        });
      },
      resetForm() {
        this.$refs.loginForm.resetFields();
      },
      RefreshVcode() {
        this.vcodeUrl = this.vcodeUrl + Math.floor(Math.random() * 100000000);
      },
    },
  };
</script>

<style scoped>
  .layout {
    background-image: url("../assets/background.svg");
    background-size: 100% 100%;
    height: 100vh;
  }

  .loginformClass {
    background: #fff;
    border: 3px solid #fff;
    border-radius: 5px;
    width: 40%;
    position: relative;
    margin: 0 auto;
    padding: 5% 0 5% 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .login-h1 {
    margin-left: 35%;
    margin-bottom: 20px;
  }

  .validcode {
    width: 100px;
    float: right;
  }

  .vlidinput {
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/components/login.vue